<template>
    <div
        class="label-page"
        id="labeldeurpage"
    >
        <spinner-text v-if="!products">
            {{ trans('pages.label.loading') }}
        </spinner-text>
        <div
            v-else
            id="labelcontent"
        >
            <div
                class="labeldeur"
                v-for="product in products"
                :key="product.ID"
            >
                <img src="images/eosol_black.png" />
                <p class="labelproducttypename">{{ product.producttypename }}</p>
                <div style="clear: both"></div>
                <p class="labelproductid">
                    {{ product.ID }}
                    <template v-if="product.groupId">
                        ({{ product.groupId }})
                    </template>
                </p>
                <p class="labelcustomer">{{ product.customername }}</p>
                <p class="labelref">
                    {{ trans('pages.label.ref1') }}
                    <b>{{ product.reference }}</b>
                </p>
                <p class="labelplace">
                    {{ trans('pages.label.ref2') }} {{ product.name }}
                </p>
                <p class="labelcolor">
                    {{ trans('pages.label.color') }} {{ product.ralnr }}
                    {{ product.raltype }}
                </p>
                <p class="labelextra">{{ product.extra }}</p>
                <div class="labelcode">
                    <barcode
                        :value="product.ID"
                        format="CODE128"
                        font-size="18"
                        text-margin="0"
                    >
                        {{ trans('pages.label.barcode') }} {{ product.ID }}
                    </barcode>
                </div>
                <p class="labeladdress">{{ trans('pages.label.address') }}</p>
            </div>
        </div>
    </div>
</template>
<script>
import SpinnerText from '../components/loader/SpinnerText';
import labelApi from '../api/label';
import IdParamMixin from '../mixins/id-param';
import VueBarcode from 'vue-barcode';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [IdParamMixin(), localization],
    components: {
        SpinnerText,
        barcode: VueBarcode,
    },
    methods: {
        load() {
            this.productId = this.$route.params.id;
            labelApi
                .productLabelDetails(
                    this.$store.getters['currentUser/getUserId'],
                    this.productId
                )
                .then((response) => {
                    this.products = response.data.data;
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.label.error_product_not_found')
                    );
                });
        },
    },
    data() {
        return {
            productId: null,
            products: null,
        };
    },
};
</script>
